import { parse, stringify } from 'qs';
import { filter, pathOr } from 'ramda';
import { isNotEmpty } from './hasValue';

/**
 * Parses a string of key/value pairs separated by '&', with the key and value separated by '='
 *
 * @param str The string to parse
 * @returns An object of the parsed key/value pairs
 */
export const parseQueryParams = (str: string) =>
  parse(str, { ignoreQueryPrefix: true });

export const getQueryParam = (
  str: string,
  paramName: string,
  defaultValue: string = ''
) => {
  const params = parseQueryParams(str);
  return pathOr(defaultValue, [paramName], params);
};

export const stringifyQueryParam = (params: any, encodeValuesOnly: boolean = true) => {
  const queryParam = filter(isNotEmpty, params)
  return stringify(
    queryParam,
    { encodeValuesOnly }
  )
}

export const getHashParam = () => {
  return window.location.hash?.split('#')?.[1]?.split(',') ?? [];
}